export default __webpack_public_path__ + "static/media/mail.f1cad55f.svg";